import React, { FC } from "react";

import { FavoritesPage } from "./Pages/FavoritesPage";
import { InsuranceFiltersContext } from "./Utils/Context/filtersContext";
import { InsuranceKeywordContext } from "./Utils/Context/keywordsContext";
import { InsuranceLabelsContext } from "./Utils/Context/labelsContext";
import { InsuranceListParams } from "../../Pages/InsuranceHome/InsuranceListParams.csharp";

export const FavoritesDoctors: FC<InsuranceListParams> = (props) => {
  return (
    <InsuranceLabelsContext labels={props.insuranceLabels}>
      <InsuranceFiltersContext>
        <InsuranceKeywordContext>
          <FavoritesPage {...props} />
        </InsuranceKeywordContext>
      </InsuranceFiltersContext>
    </InsuranceLabelsContext>
  );
};
